// importer vos composantes ici
import Youtube from './components/Youtube.js';
import Scrolly from './components/scrolly.js';
import Form from './components/form.js';
import Carousel from './components/Carousel.js';
import Header from './components/Header.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Youtube: Youtube,
      Scrolly: Scrolly,
      Carousel: Carousel,
      Form: Form,
      Header: Header,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
